import script from "./meeting-more-settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./meeting-more-settings.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__